module.exports = __webpack_public_path__ + "static/denmark-a9b7966132019199798a580c5f3a5a8e.jpeg";